import { topicIndex } from '@/mocks/homeData';

export default function TopicIndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-folder-open-line"></i>
            专题合集
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">热门专题索引</h2>
          <p className="mt-3 text-sm text-foreground-600">按赛道分类，快速找到你关心的爆料</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {topicIndex.map((topic, i) => (
            <a
              key={i}
              href="#"
              className="group flex items-start gap-4 bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${topic.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{topic.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{topic.desc}</p>
                <span className="inline-block mt-2 text-xs text-accent-600 font-medium bg-accent-50 px-2 py-0.5 rounded">{topic.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}